export default "__VITE_ASSET__DuiqLw5c__"